import React, { useState, useRef, useEffect, useMemo } from "react";
import "../../styles/leaguemultibet.css";

const LeagueMultiSelect = ({
  leagueData,
  setLeagueId,
  resetTrigger
}) => {
  const [selectedLeagues, setSelectedLeagues] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoadingLeagueData, setIsLoadingLeagueData] = useState(false);
  const [filteredLeagueData, setFilteredLeagueData] = useState([]);

  useEffect(() => {
  setIsLoadingLeagueData(true);

  const timeout = setTimeout(() => {
    if (!searchTerm) {
      setFilteredLeagueData(leagueData);
    } else {
      const lowerSearch = searchTerm.toLowerCase();
      const filtered = leagueData.filter((item) =>
        item.leaguename.toLowerCase().includes(lowerSearch)
      );
      setFilteredLeagueData(filtered);
    }
    setIsLoadingLeagueData(false);
  }, 300);

  return () => clearTimeout(timeout);
}, [leagueData, searchTerm, setIsLoadingLeagueData]);

  const toggleLeague = (leagueId) => {
    setSelectedLeagues((prevSelected) => {
      const updatedSelection = prevSelected.includes(leagueId)
        ? prevSelected.filter((id) => id !== leagueId)
        : [...prevSelected, leagueId];
      setLeagueId(updatedSelection);
      return updatedSelection;
    });
  };

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm(""); // reset search when closing dropdown
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
      if (resetTrigger) {
        setSelectedLeagues([]);
        setLeagueId([]);
      }
    }, [resetTrigger, setLeagueId]);

  return (
    <div className="dropdown-container" ref={dropdownRef}>
      <div className="dropdown-header" onClick={toggleDropdown}>
        {selectedLeagues.length > 0
          ? (() => {
              const leaguesNames = selectedLeagues
                .map(
                  (id) =>
                    leagueData.find((item) => item.leagueid === id)?.leaguename
                )
                .filter(Boolean);
              return leaguesNames.length > 2
                ? `${leaguesNames.slice(0, 1).join(", ")}...`
                : leaguesNames.join(", ");
            })()
          : "Choose League"}
        <span className={`dropdown-arrow ${isOpen ? "open" : ""}`}></span>
      </div>
      {isOpen && (
        <div className="dropdown-list">
          <div className="AF-formControl_tribet">
            <input
              type="text"
              placeholder="Search League..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              id="input_treble_search_market"
            />
          </div>

          {!isLoadingLeagueData ? (
            filteredLeagueData.length > 0 ? (
              filteredLeagueData.map((item) => (
                <div key={item.leagueid} className="AF-formControl_multibet">
                  <input
                    type="checkbox"
                    id={`multibet_league-${item.leagueid}`}
                    value={item.leagueid}
                    checked={selectedLeagues.includes(item.leagueid)}
                    onChange={() => toggleLeague(item.leagueid)}
                  />
                  <label
                    className="label"
                    htmlFor={`multibet_league-${item.leagueid}`}
                  >
                    {item.leaguename}
                  </label>
                </div>
              ))
            ) : (
              <div className="message">League not available</div>
            )
          ) : (
            <div className="message">Loading leagues...</div>
          )}
        </div>
      )}
    </div>
  );
};

export default LeagueMultiSelect;
